import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Location = ({ color = '#313634', ...rest }: Props) => {
  return (
    <Svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.99984 8.5026C8.3665 8.5026 8.68039 8.37205 8.9415 8.11094C9.20262 7.84983 9.33317 7.53594 9.33317 7.16927C9.33317 6.8026 9.20262 6.48872 8.9415 6.2276C8.68039 5.96649 8.3665 5.83594 7.99984 5.83594C7.63317 5.83594 7.31928 5.96649 7.05817 6.2276C6.79706 6.48872 6.6665 6.8026 6.6665 7.16927C6.6665 7.53594 6.79706 7.84983 7.05817 8.11094C7.31928 8.37205 7.63317 8.5026 7.99984 8.5026ZM7.99984 13.4026C9.35539 12.1582 10.3609 11.0276 11.0165 10.0109C11.6721 8.99427 11.9998 8.09149 11.9998 7.3026C11.9998 6.09149 11.6137 5.09983 10.8415 4.3276C10.0693 3.55538 9.12206 3.16927 7.99984 3.16927C6.87761 3.16927 5.93039 3.55538 5.15817 4.3276C4.38595 5.09983 3.99984 6.09149 3.99984 7.3026C3.99984 8.09149 4.32762 8.99427 4.98317 10.0109C5.63873 11.0276 6.64428 12.1582 7.99984 13.4026ZM7.99984 15.1693C6.21095 13.647 4.87484 12.2332 3.9915 10.9276C3.10817 9.62205 2.6665 8.41371 2.6665 7.3026C2.6665 5.63594 3.20262 4.30816 4.27484 3.31927C5.34706 2.33038 6.58873 1.83594 7.99984 1.83594C9.41095 1.83594 10.6526 2.33038 11.7248 3.31927C12.7971 4.30816 13.3332 5.63594 13.3332 7.3026C13.3332 8.41371 12.8915 9.62205 12.0082 10.9276C11.1248 12.2332 9.78873 13.647 7.99984 15.1693Z"
        fill={color}
      />
    </Svg>
  )
}

export default Location
